export function getImageServerBaseUrlForImage (servers, { compressedFileLocation }) {
  if (!compressedFileLocation || !Array.isArray(servers) || servers.length === 0) {
    return '';
  }
  compressedFileLocation = compressedFileLocation.toLowerCase();
  // First try to locate the imageServer where this file is hosted
  let server = servers.find((s) => compressedFileLocation.startsWith(s.path.toLowerCase()));
  // use the fallback server if match not found
  if (!server) {
    server = servers.find((s) => s.path === '*');
  }
  // Matching ImageServer not found; just return empty string (aligning with eSM impl).
  if (!server) {
    return '';
  }

  // Get the base URL from the config
  let baseUrl;
  try {
    baseUrl = new URL(server.externalLocation).toString();
  } catch (ex) { // if not a url an exception is thrown
    baseUrl = server.externalLocation
      .replace('./', '/')
      .replace('//', '/');
  }

  return baseUrl;
}
